export const MessageLengthLimit = 1000;
export const MessageLengthWarning = 950;
export const SendThrottleInterval = 2000;
export const SubjectLengthLimit = 100;
export const debounceDelay = 250;
